// extracted by mini-css-extract-plugin
module.exports = {"addElement":"AddElement_addElement__15_D9","absolute":"AddElement_absolute__jJxbX","normal":"AddElement_normal__37hOV","plusIcon":"AddElement_plusIcon__WZ_f5"};